function add_bus_days(e, s) {
    var o = e.getDay();
    return e.setDate(e.getDate() + (o >= 3 ? s + 2 : s)), e;
}
function getMobileOperatingSystem() {
    var e = navigator.userAgent || navigator.vendor || window.opera;
    return /windows phone/i.test(e) ? "Windows Phone" : /android/i.test(e) ? "Android" : /iPad|iPhone|iPod/.test(e) && !window.MSStream ? "iOS" : "unknown";
}
var not_shipping_zones_int = [
        2850,
        6280,
        3737,
        4613,
        4670,
        7315,
        7112,
        4627,
        2795,
        2325,
        2336,
        7310,
        4850,
        4892,
        4660,
        5440,
        2476,
        822,
        7306,
        4401,
        6375,
        4343,
        4474,
        3352,
        4703,
        846,
        2729,
        7150,
        4870,
        2474,
        4677,
        872,
        4807,
        4802,
        2846,
        6532,
        7216,
        4820,
        5311,
        6331,
        6332,
        6330,
        4702,
        7263,
        4722,
        4822,
        7330,
        2440,
        4650,
        6306,
        2870,
        6288,
        4740,
        4825,
        2650,
        4610,
        4817,
        2259,
        2420,
        6038,
        4370,
        5723,
        4310,
        6525,
        6225,
        2671,
        5291,
        5373,
        4285,
        2441,
        4816,
        2425,
        2311,
        6535,
        4871,
        3727,
        5730,
        4724,
        5733,
        5351,
        2460,
        885,
        4570,
        2866,
        4829,
        6632,
        4306,
        4462,
        6338,
        3371,
        4380,
        4183,
        2800,
        3468,
        5431,
        5724,
        5722,
        2631,
        7120,
        4800,
        4355,
        5255,
        5353,
        6642,
        5732,
        2834,
        2464,
        2845,
        5356,
        7264,
        6714,
        2340,
        4378,
        2330,
        2820,
        7030,
        4726,
        4620,
        4625,
        4309,
        2283,
        4819,
        3475,
        5720,
        6419,
        2338,
        2358,
        2665,
        2720,
        2449,
        2707,
        6239,
        4721,
        5701,
        2828,
        4737,
        852,
        2456,
        4880,
        6519,
        6315,
        4359,
        5157,
        2463,
        6065,
        6111,
        2361,
        2594,
        5259,
        4883,
        4311,
        2360,
        4413,
        4477,
        6290,
        2587,
        5374,
        6233,
        6069,
        7213,
        862,
        6084,
        2628,
        4895,
        2390,
        6412,
        6428,
        6701,
        2825,
        4861,
        2372,
        2422,
        2484,
        4361,
        2365,
        5601,
        3670,
        6317,
        7270,
        6475,
        6302,
        6521,
        6383,
        4875,
        2333,
        4674,
        4454,
        2446,
        6082,
        5671,
        5354,
        7307,
        4470,
        2359,
        2447,
        6562,
        832,
        6258,
        2549,
        5203,
        2370,
        2867,
        6253,
        4741,
        6443,
        2831,
        4382,
        4352,
        4455,
        6606,
        2830,
        6304,
        3666,
        4876,
        4860,
        4873,
        6503,
        7265,
        4630,
        2871,
        6450,
        6440,
        4730,
        2479,
        6213,
        2580,
        6390,
        2347,
        2396,
        4601,
        5432,
        6479,
        6510,
        4725,
        4714,
        4465,
        4615,
        4605,
        5641,
        5434,
        2852,
        4420,
        5495,
        6275,
        6209,
        4416,
        2710,
        4809,
        4872,
        2840,
        4490,
        6712,
        2799,
        2380,
        2439,
        845,
        2261,
        2536,
        3730,
        6284,
        4718,
        4478,
        4818,
        6530,
        6472,
        2827,
        4886,
        6394,
        7215,
        4385,
        7252,
        6556,
        6260,
        6224,
        2680,
        4406,
        2824,
        6353,
        4626,
        4487,
        6566,
        4723,
        4810,
        4408,
        2454,
        7254,
        2581,
        2337,
        2790,
        7212,
        6477,
        2355,
        2803,
        2798,
        6223,
        4754,
        6463,
        6255,
        2818,
        2480,
        4353,
        838,
        3472,
        4313,
        2453,
        3490,
        2339,
        2583,
        4621,
        6725,
        4390,
        2829,
        2804,
        4715,
        4854,
        2810,
        4805,
        4488,
        6574,
        6502,
        6430,
        4852,
        5262,
        6214,
        2655,
        4482,
        2700,
        2844,
        2430,
        7140,
        7321,
        4600,
        2787,
        4472,
        2343,
        4717,
        5700,
        5357,
        2721,
        4405,
        2713,
        4799,
        7255,
        2428,
        7260,
        6208,
        2450,
        4468,
        2877,
        6320,
        2429,
        3678,
        2443,
        5655,
        2865,
        6424,
        2876,
        2826,
        4425,
        2849,
        2409,
        3669,
        6392,
        6568,
        5731,
        2423,
        2357,
        5719,
        2722,
        4356,
        6722,
        6423,
        5690,
        4671,
        5330,
        2711,
        3728,
        7177,
        6429,
        4655,
        6262,
        6431,
        2652,
        2586,
        2346,
        6391,
        6286,
        4678,
        5309,
        854,
        5607,
        6432,
        6312,
        2868,
        6211,
        6333,
        2864,
        4404,
        3675,
        6623,
        3735,
        2644,
        3725,
        6237,
        6316,
        6244,
        7302,
        5381,
        5670,
        6285,
        4808,
        7304,
        7261,
        6251,
        7175,
        2381,
        6043,
        2839,
        7262,
        4412,
        5267,
        4357,
        2472,
        2705,
        2848,
        6398,
        3673,
        2880,
        4757,
        6318,
        3749,
        6418,
        5433,
        2875,
        5252,
        861,
        4387,
        4403,
        5254,
        2250,
        6401,
        2835,
        6373,
        4492,
        6484,
        2387,
        2794,
        5266,
        6230,
        6522,
        2823,
        4427,
        4419,
        7256,
        3726,
        6410,
        4494,
        6613,
        6467,
        6452,
        2328,
        6227,
        2672,
        4830,
        2792,
        2653,
        6421,
        6490,
        2386,
        2821,
        4742,
        4885,
        5605,
        6122,
        2669,
        6726,
        6466,
        2424,
        7325,
        4798,
        6569,
        2462,
        5341,
        6728,
        4719,
        6743,
        7316,
        4828,
        7210,
        4521,
        5640,
        6710,
        6627,
        5419,
        7257,
        5204,
        6707,
        6328,
        6271,
        2371,
        6041,
        6033,
        5680,
        2791,
        5301,
        4849,
        7173,
        4739,
        6517,
        4344,
        4823,
        4806,
        2329,
        6507,
        7109,
        4407,
        5422,
        2775,
        6511,
        2678,
        4608,
        4475,
        4606,
        6395,
        5134,
        6751,
        5660,
        6798,
        6564,
        4705,
        4471,
        4879,
        6850,
        4824,
        5654,
        6731,
        6308,
        2833,
        4707,
        4804,
        4415,
        2666,
        2832,
        6311,
        4571,
        4858,
        4815,
        4184,
        6210,
        5261,
        6219,
        6638,
        4479,
        839,
        6512,
        4422,
        5264,
        6515,
        5650,
        4402,
        5611,
        2879,
        6393,
        4733,
        6426,
        2315,
        850,
        6720,
        4745,
        4375,
        6336,
        6485,
        4877,
        6420,
        6321,
        5235,
        6236,
        2411,
        6640,
        6067,
        5600,
        6434,
        6407,
        5214,
        4374,
        6609,
        6713,
        2793,
        5642,
        2706,
        3701,
        841,
        4855,
        5355,
        4497,
        6324,
        6537,
        4753,
        6630,
        6567,
        4735,
        4486,
        6411,
        6409,
        4354,
        6461,
        4424,
        6740,
        4712,
        6363,
        6425,
        6350,
        840,
        6355,
        4728,
        6281,
        4480,
        4821,
        6608,
        6705,
        6309,
        6370,
        6232,
        6034,
        3746,
        4720,
        5713,
        4371,
        6518,
        5734,
        2806,
        4491,
        3739,
        4581,
        4874,
        4888,
        4481,
        4756,
        7214,
        5502,
        2421,
        6346,
        6337,
        6765,
        6359,
        6716,
        2258,
        6396,
        5421,
        6476,
        880,
        4345,
        2836,
        6531,
        6448,
        6083,
        4676,
        4377,
        5710,
        4743,
        4515,
        6256,
        4423,
        6509,
        6335,
        6174,
        4865,
        6723,
        6468,
        2838,
        4856,
        6460,
        6415,
        2482,
        4421,
        7466,
        4347,
        7469,
        6446,
        6403,
        6514,
        6254,
        2809,
        4751,
        6405,
        2658,
        4418,
        6513,
        2356,
        6770,
        6215,
        4803,
        6433,
        6361,
        6220,
        6356,
        4801,
        873,
        4887,
        6313,
        2675,
        5717,
        6462,
        6413,
        4612,
        6799,
        6125,
        6348,
        5141,
        4890,
        4493,
        2448,
        4738,
        4727,
        2466,
        6721,
        4731,
        886,
        4426,
        4410,
        6124,
        4383,
        6612,
        6753,
        6365,
        4736,
        6516,
        6536,
        6442,
        6044,
        6358,
        6176,
        5307,
        5304,
        4891,
        851,
        7176,
        6323,
        6182,
        6126,
        4373,
        4498,
        4881,
        6367,
        6605,
        6603,
        6733,
        5661,
        6427,
        2807,
        6352,
        6470,
        6489,
        4388,
        6385,
        6646,
        6438,
        7467,
        6180,
        5302,
        6616,
        6170,
        6437,
        6079,
        4673,
        2898,
        6447,
        6240,
        6465,
        837,
        6760,
        6078,
        4611,
        4746,
        6614,
        2842,
        6436,
        6625,
        6575,
        6506,
        2415,
        6504,
        4744,
        6221,
        6351,
        5210,
        6528,
        6369,
        3732,
        6501,
        4461,
        6252,
        5340,
        6123,
        4467,
        2869,
        4732,
        2681,
        6207,
        7259,
        6414,
        6326,
        5412,
        4614,
        4859,
        4417,
        2899,
        6445,
        4496,
        6488,
        6473,
        6487,
        7172,
        6480,
        6758,
        6341,
        6121,
        4706,
        5725,
        3738,
        5652,
        6384,
        6754,
        6081,
        5220,
        6620,
        6572,
        4428,
        6229,
        6631,
        847,
        6357,
        6343,
        6327,
        6397,
        6718,
        6226,
        7209,
        6639,
        6042,
        6173,
        6386,
        6761,
        4857,
        6175,
        6368,
        6635,
        4363,
        6181,
        7139,
        6628,
        6762,
        860,
        6322,
        6711,
        4709,
        853,
        4882,
        4411,
        2874,
        2410,
        6037,
        6422,
        6505,
        6228,
        4704,
        3733,
        6243,
        4713,
        6558,
        6560,
        4489,
        6282,
        6035,
        2703,
        5653,
        6218,
        6372,
        6571,
        3067,
    ],
    not_shipping_zones_str = not_shipping_zones_int.map(String);
async function updateCart() {
    await setTimeout(function () {
        document.querySelector(".form-icon").click();
    }, 4e3);
}
jQuery(document).ready(function (e) {
    let s = [],
        o = [
            { state: "NT", postcode: "800", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "810", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "812", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "815", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "820", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "822", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "828", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "829", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "830", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "832", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "835", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "836", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "837", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "838", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "839", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "840", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "841", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "845", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "846", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "847", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "850", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "852", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "853", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "854", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "860", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "861", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "862", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "870", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "872", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "880", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "885", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "886", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2000", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2006", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2007", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2008", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2009", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2010", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2011", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2015", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2016", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2017", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2018", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2019", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2020", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2021", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2022", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2023", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2024", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2025", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2026", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2027", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2028", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2029", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2030", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2031", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2032", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2033", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2034", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2035", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2036", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2037", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2038", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2039", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2040", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2041", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2042", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2043", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2044", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2045", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2046", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2047", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2048", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2049", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2050", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2060", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2061", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2062", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2063", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2064", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2065", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2066", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2067", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2068", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2069", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2070", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2071", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2072", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2073", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2074", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2075", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2076", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2077", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2079", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2080", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2081", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2082", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2083", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2084", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2085", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2086", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2087", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2088", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2089", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2090", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2092", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2093", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2094", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2095", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2096", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2097", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2099", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2100", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2101", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2102", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2103", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2104", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2105", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2106", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2107", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2108", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2110", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2111", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2112", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2113", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2114", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2115", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2116", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2117", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2118", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2119", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2120", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2121", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2122", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2125", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2126", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2127", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2128", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2130", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2131", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2132", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2133", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2134", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2135", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2136", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2137", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2138", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2140", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2141", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2142", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2143", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2144", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2145", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2146", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2147", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2148", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2150", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2151", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2152", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2153", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2154", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2155", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2156", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2157", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2158", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2159", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2160", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2161", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2162", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2163", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2164", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2165", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2166", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2167", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2168", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2170", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2171", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2173", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2174", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2176", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2177", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2190", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2191", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2192", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2193", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2194", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2195", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2196", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2197", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2198", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2199", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2200", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2203", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2204", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2205", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2206", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2207", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2208", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2209", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2210", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2211", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2212", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2213", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2214", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2216", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2217", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2218", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2219", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2220", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2221", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2222", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2223", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2224", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2225", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2226", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2227", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2228", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2229", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2230", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2231", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2232", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2233", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2234", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2250", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2251", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2256", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2257", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2258", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2259", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2260", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2261", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2262", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2263", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2264", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2265", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2267", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2278", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2280", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2281", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2282", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2283", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2284", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2285", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2286", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2287", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2289", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2290", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2291", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2292", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2293", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2294", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2295", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2296", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2297", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2298", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2299", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2300", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2302", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2303", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2304", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2305", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2306", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2307", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2308", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2309", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2311", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2312", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2314", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2315", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2316", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2317", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2318", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2319", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2320", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2321", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2322", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2323", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2324", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2325", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2326", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2327", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2328", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2329", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2330", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2333", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2334", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2335", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2336", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2337", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2338", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2339", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2340", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2341", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2342", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2343", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2344", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2345", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2346", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2347", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2350", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2352", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2353", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2354", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2355", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2356", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2357", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2358", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2359", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2360", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2361", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2365", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2369", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2370", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2371", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2372", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2379", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2380", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2381", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2382", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2386", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2387", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2388", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2390", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2395", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2396", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2397", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2398", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2399", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2400", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2401", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2402", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2403", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2404", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2405", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2406", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2408", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2409", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2410", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2411", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2415", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2420", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2421", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2422", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2423", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2424", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2425", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2426", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2427", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2428", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2429", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2430", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2431", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2439", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2440", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2441", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2443", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2444", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2445", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2446", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2447", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2448", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2449", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2450", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2452", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2453", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2454", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2455", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2456", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2460", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2462", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2463", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2464", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2465", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2466", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2469", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2470", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2471", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2472", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2473", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2474", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2475", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2476", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2477", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2478", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2479", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2480", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2481", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2482", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2483", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2484", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2485", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2486", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2487", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2488", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2489", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2490", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2500", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2502", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2505", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2506", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2508", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2515", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2516", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2517", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2518", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2519", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2525", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2526", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2527", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2528", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2529", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2530", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2533", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2534", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2535", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2536", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2537", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2538", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2539", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2540", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2541", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2545", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2546", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2548", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2549", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2550", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2551", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2556", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2557", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2558", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2559", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2560", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2563", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2564", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2565", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2566", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2567", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2568", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2569", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2570", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2571", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2572", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2573", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2574", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2575", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2576", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2577", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2578", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2579", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2580", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2581", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2582", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2583", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2584", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2585", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2586", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2587", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2588", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2590", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2594", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2600", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2601", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2602", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2603", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2604", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2605", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2606", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2607", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2608", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2609", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2611", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2612", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2614", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2615", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2617", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2618", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2619", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2620", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2621", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2622", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2623", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2624", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2625", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2626", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2627", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2628", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2629", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2630", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2631", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2632", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2633", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2640", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2641", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2642", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2643", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2644", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2645", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2646", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2647", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2648", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2649", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2650", ddays: "4-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2651", ddays: "4-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2652", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2653", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2655", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2656", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2658", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2659", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2660", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2661", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2663", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2665", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2666", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2668", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2669", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2671", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2672", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2675", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2680", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2681", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2700", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2701", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2702", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2703", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2705", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2706", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2707", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2710", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2711", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2712", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2713", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2714", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2715", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2716", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2717", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2720", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2721", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2722", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2725", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2726", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2727", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2729", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2730", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2731", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2732", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2733", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2734", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2735", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2736", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2737", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2738", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2739", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2745", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2747", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2748", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2749", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2750", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2752", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2753", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2753", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2754", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2756", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2757", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2758", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2759", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2760", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2761", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2762", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2763", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2765", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2766", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2767", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2768", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2769", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2770", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2773", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2774", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2775", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2776", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2777", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2778", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2779", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2780", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2782", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2783", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2784", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2785", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2786", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2787", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2790", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2791", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2792", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2793", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2794", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2795", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2797", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2798", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2799", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2800", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2803", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2804", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2805", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2806", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2807", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2808", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2809", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2810", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2820", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2821", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2823", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2824", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2825", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2827", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2828", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2829", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2830", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2831", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2832", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2833", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2834", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2835", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2836", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2839", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2840", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2842", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2843", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2844", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2845", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2846", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2847", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2848", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2849", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2850", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2852", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2864", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2865", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2866", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2867", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2868", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2869", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2870", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2871", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2873", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2874", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2875", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2876", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2877", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2878", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2879", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2880", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2898", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2899", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2900", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2902", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2903", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2904", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2905", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2906", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2911", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2912", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2913", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2914", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            {
                state: "VIC METRO",
                postcode: "3000",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3002",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3003",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3004",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3005",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3006",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3008",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3010",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3011",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3012",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3013",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3015",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3016",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3018",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3019",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3020",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3021",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3022",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3023",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3024",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3025",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3026",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3027",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3028",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3029",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3030",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3031",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3032",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3033",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3034",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3036",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3037",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3038",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3039",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3040",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3041",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3042",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3043",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3044",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3045",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3046",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3047",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3048",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3049",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3050",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3051",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3052",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3053",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3054",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3055",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3056",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3057",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3058",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3059",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3060",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3061",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3062",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3063",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3064",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3065",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3066",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3068",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3070",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3071",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3072",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3073",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3074",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3075",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3076",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3078",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3079",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3081",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3082",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3083",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3084",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3085",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3087",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3088",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3089",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            { state: "VICTORIA", postcode: "3090", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3091", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            {
                state: "VIC METRO",
                postcode: "3093",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3094",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3095",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            { state: "VICTORIA", postcode: "3096", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3097", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3099", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            {
                state: "VIC METRO",
                postcode: "3101",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3102",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3103",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3104",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3105",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3106",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3107",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3108",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3109",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3111",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3113",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3114",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3115",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3116",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3121",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3122",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3123",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3124",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3125",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3126",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3127",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3128",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3129",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3130",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3131",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3132",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3133",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3134",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3135",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3136",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3137",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3138",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3139",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3140",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3141",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3142",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3143",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3144",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3145",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3146",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3147",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3148",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3149",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3150",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3151",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3152",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3153",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3154",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3155",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3156",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            { state: "VICTORIA", postcode: "3158", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3159", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            {
                state: "VIC METRO",
                postcode: "3160",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3161",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3162",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3163",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3165",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3166",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3167",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3168",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3169",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3170",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3171",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3172",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3173",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3174",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3175",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3177",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3178",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3179",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3180",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3181",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3182",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3183",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3184",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3185",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3186",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3187",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3188",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3189",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3190",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3191",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3192",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3193",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3194",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3195",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3196",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3197",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3198",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3199",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3200",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3201",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3202",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3204",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3205",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3206",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3207",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            { state: "VICTORIA", postcode: "3211", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3212", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3213", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3214", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3215", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3216", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3217", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3218", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3219", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3220", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3221", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3222", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3223", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3224", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3225", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3226", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3227", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3228", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3230", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3231", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3232", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3233", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3235", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3236", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3237", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3238", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3239", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3240", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3241", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3242", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3243", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3249", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3250", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3251", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3254", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3260", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3264", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3265", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3266", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3267", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3268", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3269", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3270", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3271", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3272", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3273", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3274", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3275", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3276", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3277", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3278", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3279", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3280", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3281", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3282", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3283", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3284", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3285", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3286", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3287", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3289", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3292", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3293", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3294", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3300", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3301", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3302", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3303", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3304", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3305", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3309", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3310", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3311", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3312", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3314", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3315", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3317", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3318", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3319", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3321", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3322", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3323", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3324", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3325", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3328", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3329", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3330", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3331", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3332", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3333", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3334", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3335", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3336", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3337", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3338", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3340", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3341", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3342", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3345", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3350", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3351", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3352", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3354", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3355", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3356", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3357", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3358", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3360", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3361", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3363", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3364", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3370", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3371", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3373", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3374", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3375", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3377", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3378", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3379", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3380", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3381", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3384", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3385", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3387", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3388", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3390", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3391", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3392", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3393", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3395", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3396", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3400", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3401", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3407", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3409", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3412", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3413", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3414", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3415", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3418", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3419", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3420", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3423", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3424", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3427", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3428", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3429", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3430", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3431", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3432", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3433", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3434", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3435", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3437", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3438", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3440", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3441", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3442", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3444", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3446", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3447", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3448", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3450", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3451", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3453", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3458", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3460", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3461", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3462", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3463", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3464", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3465", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3467", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3468", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3469", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3472", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3475", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3477", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3478", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3480", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3482", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3483", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3485", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3487", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3488", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3489", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3490", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3491", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3494", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3496", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3498", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3500", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3501", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3505", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3506", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3507", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3509", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3512", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3515", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3516", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3517", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3518", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3520", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3521", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3522", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3523", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3525", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3527", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3529", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3530", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3531", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3533", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3537", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3540", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3542", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3544", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3546", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3549", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3550", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3551", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3555", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3556", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3557", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3558", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3559", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3561", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3562", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3563", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3564", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3565", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3566", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3567", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3568", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3570", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3571", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3572", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3573", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3575", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3576", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3579", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3580", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3581", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3583", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3584", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3585", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3586", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3588", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3589", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3590", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3591", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3594", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3595", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3596", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3597", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3599", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3607", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3608", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3610", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3612", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3614", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3616", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3617", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3618", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3620", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3621", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3622", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3623", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3624", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3629", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3630", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3631", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3633", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3634", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3635", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3636", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3637", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3638", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3639", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3640", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3641", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3644", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3646", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3647", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3649", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3658", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3659", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3660", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3662", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3663", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3664", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3665", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3666", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3669", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3670", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3672", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3673", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3675", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3677", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3678", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3682", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3683", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3685", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3687", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3688", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3690", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3691", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3694", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3695", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3697", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3698", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3699", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3700", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3701", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3704", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3705", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3707", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3708", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3709", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3711", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3712", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3713", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3714", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3715", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3717", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3718", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3719", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3720", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3722", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3723", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3725", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3726", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3727", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3728", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3730", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3732", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3733", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3735", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3738", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3739", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3740", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3741", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3744", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3746", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3747", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3749", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3750", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3751", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            {
                state: "VIC METRO",
                postcode: "3752",
                ddays: "2-7 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            { state: "VICTORIA", postcode: "3753", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3754", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3755", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3756", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3757", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3758", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3759", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3760", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3761", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3762", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3763", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3764", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3765", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3766", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3767", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3770", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3775", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3777", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3778", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3779", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3781", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3782", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3783", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3785", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3786", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3787", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3788", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3789", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3791", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3792", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3793", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3795", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3796", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3797", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3799", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            {
                state: "VIC METRO",
                postcode: "3800",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3802",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3803",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            { state: "VICTORIA", postcode: "3804", ddays: "1-6 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3805", ddays: "1-6 Business Days", note: "", noteonweb: "", FIELD7: null },
            {
                state: "VIC METRO",
                postcode: "3806",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            { state: "VICTORIA", postcode: "3807", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3808", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3809", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3810", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3812", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3813", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3814", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3815", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3816", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3818", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3820", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3821", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3822", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3823", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3824", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3825", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3831", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3832", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3833", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3835", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3840", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3842", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3844", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3847", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3850", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3851", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3852", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3854", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3856", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3857", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3858", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3859", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3860", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3862", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3864", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3865", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3869", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3870", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3871", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3873", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3874", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3875", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3878", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3880", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3882", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3885", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3886", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3887", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3888", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3889", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3890", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3891", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3892", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3893", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3895", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3896", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3898", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3900", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3902", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3903", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3904", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3909", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3910", ddays: "1-6 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3911", ddays: "1-6 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3912", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3913", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3915", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3916", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3918", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3919", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3920", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3921", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3922", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3923", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3925", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3926", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3927", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3928", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3929", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3930", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3931", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3933", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3934", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3936", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3937", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3938", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3939", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3940", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3941", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3942", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3943", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3944", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3945", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3946", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3950", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3951", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3953", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3954", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3956", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3957", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3958", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3959", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3960", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3962", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3964", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3965", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3966", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3967", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3971", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            {
                state: "VIC METRO",
                postcode: "3975",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            {
                state: "VIC METRO",
                postcode: "3976",
                ddays: "1-6 Business Days",
                note: "Same Day Delivery",
                noteonweb: "We offer same-day delivery in Melbourne metro region on majority of our products. Same day delivery applies for orders purchased before 9 am in the morning for the following post codes\n No Delivery on Weekends",
                FIELD7: 1,
            },
            { state: "VICTORIA", postcode: "3977", ddays: "1-6 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3978", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3979", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3980", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3981", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3984", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3987", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3988", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3990", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3991", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3992", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3995", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VICTORIA", postcode: "3996", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4000", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4001", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4005", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4006", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4007", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4008", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4009", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4010", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4011", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4012", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4013", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4014", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4017", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4018", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4019", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4020", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4021", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4022", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4025", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4030", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4031", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4032", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4034", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4035", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4036", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4037", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4051", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4053", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4054", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4055", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4059", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4060", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4061", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4064", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4065", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4066", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4067", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4068", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4069", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4070", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4072", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4073", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4074", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4075", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4076", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4077", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4078", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4101", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4102", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4103", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4104", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4105", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4106", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4107", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4108", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4109", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4110", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4111", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4112", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4113", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4114", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4115", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4116", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4117", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4118", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4119", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4120", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4121", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4122", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4123", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4124", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4125", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4127", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4128", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4129", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4130", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4131", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4132", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4133", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4151", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4152", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4153", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4154", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4155", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4156", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4157", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4158", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4159", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4160", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4161", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4163", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4164", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4165", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4169", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4170", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4171", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4172", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4173", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4174", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4178", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4179", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4183", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4184", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4205", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4207", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4208", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4209", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4210", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4211", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4212", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4213", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4214", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4215", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4216", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4217", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4218", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4219", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4220", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4221", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4223", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4224", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4225", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4226", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4227", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4228", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4229", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4230", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4270", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4271", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4272", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4275", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4280", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4285", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4287", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4300", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4301", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4303", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4304", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4305", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4306", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4307", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4309", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4310", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4311", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4312", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4313", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4314", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4340", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4341", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4342", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4343", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4344", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4345", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4346", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4347", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4350", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4352", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4353", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4354", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4355", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4356", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4357", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4358", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4359", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4360", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4361", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4362", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4363", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4364", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4365", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4370", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4371", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4372", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4373", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4374", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4375", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4376", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4377", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4378", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4380", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4381", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4382", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4383", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4384", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4385", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4387", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4388", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4390", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4400", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4401", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4402", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4403", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4404", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4405", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4406", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4407", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4408", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4410", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4411", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4412", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4413", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4415", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4416", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4417", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4418", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4419", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4420", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4421", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4422", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4423", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4424", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4425", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4426", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4427", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4428", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4454", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4455", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4461", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4462", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4465", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4467", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4468", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4470", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4471", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4472", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4474", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4475", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4477", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4478", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4479", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4480", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4481", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4482", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4486", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4487", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4488", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4489", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4490", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4491", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4492", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4493", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4494", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4496", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4497", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4498", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4500", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4501", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4502", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4503", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4503", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4504", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4505", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4506", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4507", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4508", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4509", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4510", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4511", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4512", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4514", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4515", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4516", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4517", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4518", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4519", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4520", ddays: "4-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4521", ddays: "4-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4550", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4551", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4552", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4553", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4554", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4555", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4556", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4557", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4558", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4559", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4560", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4561", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4562", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4563", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4564", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4565", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4566", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4567", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4568", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4569", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4570", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4571", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4572", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4573", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4574", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4575", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4580", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4581", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4600", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4601", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4605", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4606", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4608", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4610", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4611", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4612", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4613", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4614", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4615", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4620", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4621", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4625", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4626", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4627", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4630", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4650", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4655", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4659", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4660", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4662", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4670", ddays: "4-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4671", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4673", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4674", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4676", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4677", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4678", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4680", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4694", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4695", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4697", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4699", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4700", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4701", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4702", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4703", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4704", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4705", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4706", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4707", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4709", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4710", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4711", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4712", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4713", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4714", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4715", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4716", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4717", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4718", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4719", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4720", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4721", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4722", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4723", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4724", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4725", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4726", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4727", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4728", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4730", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4731", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4732", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4733", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4735", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4736", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4737", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4738", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4739", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4740", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4741", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4742", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4743", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4744", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4745", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4746", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4750", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4751", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4753", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4754", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4756", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4757", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4798", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4799", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4800", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4801", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4802", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4803", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4804", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4805", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4806", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4807", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4808", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4809", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4810", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4811", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4812", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4813", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4814", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4815", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4816", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4817", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4818", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4819", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4820", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4821", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4822", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4823", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4824", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4825", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4828", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4829", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4830", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4849", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4850", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4852", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4854", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4855", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4856", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4857", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4858", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4859", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4860", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4861", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4865", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4868", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4869", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4870", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4871", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4872", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4873", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4874", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4875", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4876", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4877", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4878", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4879", ddays: "5-10 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4880", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4881", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4882", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4883", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4884", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4885", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4886", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4887", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4888", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4890", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4891", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4895", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5000", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5005", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5006", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5007", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5008", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5009", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5010", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5011", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5012", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5013", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5014", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5015", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5016", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5017", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5018", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5019", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5020", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5021", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5022", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5023", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5024", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5025", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5031", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5032", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5033", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5034", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5035", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5037", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5038", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5039", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5040", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5041", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5042", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5043", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5044", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5045", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5046", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5047", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5048", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5049", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5050", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5051", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5052", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5061", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5062", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5063", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5064", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5065", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5066", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5067", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5068", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5069", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5070", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5072", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5073", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5074", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5075", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5076", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5081", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5082", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5083", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5084", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5085", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5086", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5087", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5088", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5089", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5090", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5091", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5092", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5093", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5094", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5095", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5096", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5097", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5098", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5106", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5107", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5108", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5109", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5110", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5111", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5112", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5113", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5114", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5115", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5116", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5117", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5118", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5120", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5121", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5125", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5126", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5127", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5131", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5132", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5133", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5134", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5136", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5137", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5138", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5139", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5140", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5141", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5142", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5144", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5150", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5151", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5152", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5153", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5154", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5155", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5156", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5157", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5158", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5159", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5160", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5161", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5162", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5163", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5164", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5165", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5166", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5167", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5168", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5169", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5170", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5171", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5172", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5173", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5174", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5201", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5202", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5203", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5204", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5210", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5211", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5212", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5213", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5214", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5220", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5221", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5222", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5223", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5231", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5232", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5233", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5234", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5235", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5236", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5237", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5238", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5240", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5241", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5242", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5243", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5244", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5245", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5250", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5251", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5252", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5253", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5254", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5255", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5256", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5259", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5260", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5261", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5262", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5263", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5264", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5265", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5266", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5267", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5268", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5269", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5270", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5271", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5272", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5273", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5275", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5276", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5277", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5278", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5279", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5280", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5290", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5291", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5301", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5302", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5303", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5304", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5306", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5307", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5308", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5309", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5310", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5311", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5320", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5321", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5322", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5330", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5331", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5332", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5333", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5340", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5341", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5342", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5343", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5344", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5345", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5346", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5350", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5351", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5352", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5353", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5354", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5355", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5356", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5357", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5360", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5371", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5372", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5373", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5374", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5381", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5400", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5401", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5410", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5411", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5412", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5413", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5414", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5415", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5416", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5417", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5418", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5419", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5420", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5421", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5422", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5431", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5432", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5433", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5434", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5440", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5451", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5452", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5453", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5454", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5455", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5460", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5461", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5462", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5464", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5470", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5471", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5472", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5473", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5480", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5481", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5482", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5483", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5485", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5490", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5491", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5493", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5495", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5501", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5502", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5510", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5520", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5521", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5522", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5523", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5540", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5550", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5552", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5554", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5555", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5556", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5558", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5560", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5570", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5571", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5572", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5573", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5575", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5576", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5577", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5580", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5581", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5582", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5583", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5600", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5601", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5602", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5603", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5604", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5605", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5606", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5607", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5608", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5609", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5630", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5631", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5632", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5633", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5640", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5641", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5642", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5650", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5651", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5652", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5653", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5654", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5655", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5660", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5661", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5670", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5671", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5680", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5690", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5700", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5710", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5720", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5722", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5723", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5724", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5725", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5730", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5731", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5732", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5733", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5734", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5950", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6000", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6003", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6004", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6005", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6006", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6007", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6008", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6009", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6010", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6011", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6012", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6014", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6015", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6016", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6017", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6018", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6019", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6020", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6021", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6022", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6023", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6023", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6024", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6025", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6026", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6027", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6028", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6029", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6030", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6031", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6032", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6033", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6034", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6035", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6036", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6037", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6038", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6041", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6042", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6043", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6044", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6050", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6051", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6052", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6053", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6054", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6055", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6056", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6057", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6058", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6059", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6060", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6061", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6062", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6063", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6064", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6065", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6066", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6067", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6068", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6069", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6070", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6071", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6072", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6073", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6074", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6076", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6081", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6082", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6083", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6084", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6090", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6100", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6101", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6102", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6103", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6104", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6105", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6106", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6107", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6108", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6109", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6110", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6111", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6112", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6121", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6122", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6123", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6124", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6125", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6126", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6147", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6148", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6149", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6150", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6151", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6152", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6153", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6154", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6155", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6156", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6157", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6158", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6159", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6160", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6161", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6162", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6163", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6164", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6165", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6166", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6167", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6168", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6169", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6170", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6171", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6172", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6173", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6174", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6175", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6176", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6180", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6181", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6182", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6207", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6208", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6209", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6210", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6211", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6213", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6214", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6215", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6218", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6220", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6221", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6223", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6224", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6225", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6226", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6227", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6228", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6229", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6230", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6232", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6233", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6236", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6237", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6239", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6240", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6243", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6244", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6251", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6252", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6253", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6254", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6255", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6256", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6258", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6260", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6262", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6271", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6275", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6280", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6281", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6282", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6284", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6285", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6286", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6288", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6290", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6302", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6304", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6306", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6308", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6309", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6311", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6312", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6313", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6315", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6316", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6317", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6318", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6320", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6321", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6322", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6323", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6324", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6326", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6327", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6328", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6330", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6333", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6335", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6336", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6337", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6338", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6341", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6343", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6346", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6348", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6350", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6351", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6352", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6353", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6355", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6356", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6357", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6358", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6359", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6361", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6363", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6365", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6367", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6368", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6369", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6370", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6372", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6373", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6375", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6383", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6384", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6385", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6386", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6390", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6391", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6392", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6393", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6394", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6395", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6396", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6397", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6398", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6401", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6403", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6405", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6407", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6409", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6410", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6411", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6412", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6413", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6414", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6415", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6418", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6419", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6420", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6421", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6422", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6423", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6424", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6425", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6426", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6427", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6428", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6429", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6430", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6431", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6432", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6433", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6434", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6436", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6437", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6438", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6440", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6442", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6443", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6445", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6446", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6447", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6448", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6450", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6452", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6460", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6461", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6462", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6463", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6465", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6466", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6467", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6468", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6470", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6472", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6473", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6475", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6476", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6477", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6479", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6480", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6484", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6485", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6487", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6488", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6489", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6490", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6501", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6502", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6503", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6504", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6505", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6506", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6507", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6509", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6510", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6511", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6512", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6513", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6514", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6515", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6516", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6517", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6518", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6519", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6521", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6522", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6525", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6528", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6530", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6532", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6535", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6536", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6537", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6556", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6558", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6560", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6562", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6564", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6566", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6567", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6568", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6569", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6571", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6572", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6574", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6575", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6603", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6605", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6606", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6608", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6609", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6612", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6613", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6614", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6616", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6620", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6623", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6625", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6627", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6628", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6630", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6631", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6632", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6635", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6638", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6639", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6640", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6642", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6646", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6701", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6705", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6707", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6710", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6711", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6712", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6713", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6714", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6716", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6718", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6720", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6721", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6722", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6723", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6725", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6726", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6728", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6731", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6733", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6740", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6743", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6751", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6753", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6754", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6758", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6760", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6761", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6762", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6765", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6770", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6798", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6799", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6850", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7000", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7001", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7004", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7005", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7007", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7008", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7009", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7010", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7011", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7012", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7015", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7016", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7017", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7018", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7019", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7020", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7021", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7022", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7023", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7024", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7025", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7026", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7027", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7030", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7050", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7052", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7053", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7054", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7055", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7109", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7112", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7113", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7116", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7117", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7119", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7120", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7139", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7140", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7150", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7151", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7155", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7162", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7163", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7170", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7171", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7172", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7173", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7174", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7175", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7176", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7177", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7178", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7179", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7180", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7182", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7183", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7184", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7185", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7186", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7187", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7190", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7209", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7210", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7211", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7212", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7213", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7214", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7215", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7216", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7248", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7249", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7250", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7252", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7253", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7254", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7255", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7256", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7257", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7258", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7259", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7260", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7261", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7262", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7263", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7264", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7265", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7267", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7268", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7270", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7275", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7276", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7277", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7290", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7291", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7292", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7300", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7301", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7302", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7303", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7304", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7305", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7306", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7307", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7310", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7315", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7316", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7320", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7321", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7322", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7325", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7330", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7331", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7466", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7467", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7468", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7469", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7470", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VIC", postcode: "3737", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4892", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6331", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6332", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2708", ddays: "1-6 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2004", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "871", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5701", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2179", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1209", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2890", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "200", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2555", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6942", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2796", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VIC", postcode: "3554", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2818", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2826", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5719", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "5719", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2610", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5715", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "811", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2178", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2252", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "909", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2678", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4002", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2139", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6219", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5611", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5713", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5960", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4003", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VIC", postcode: "3841", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VIC", postcode: "3234", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6531", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2838", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6077", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2796", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4222", ddays: "5-9 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1220", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2091", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "873", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5717", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1635", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2175", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2310", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1481", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2891", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "851", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2442", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5071", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1484", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6966", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6079", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5717", ddays: "6-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1602", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1900", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1902", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2109", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6945", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6078", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6936", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6960", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2348", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1670", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2058", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6905", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VIC", postcode: "3110", ddays: "1-6 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "3110", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6832", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6849", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6831", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2172", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1226", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2755", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "TAS", postcode: "7470", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6958", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "QLD", postcode: "4029", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1221", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1701", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "813", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VIC", postcode: "3176", ddays: "1-6 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1781", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1811", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2331", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2521", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1416", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2012", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6904", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2129", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "ACT", postcode: "2901", ddays: "3-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2351", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2052", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "834", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6925", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "WA", postcode: "6986", ddays: "6-11 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1515", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "1851", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "821", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "906", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NT", postcode: "907", ddays: "8-13 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "VIC", postcode: "3689", ddays: "2-7 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "SA", postcode: "5246", ddays: "4-8 Business Days", note: "", noteonweb: "", FIELD7: null },
            { state: "NSW", postcode: "2002", ddays: "3-7 Business Days", note: "", noteonweb: "", FIELD7: null },
        ];
    for (var t, n = 0; n < o.length; n++) {
        var a = o[n].postcode;
        s.push(a);
    }
        e(document).on("click", ".post_check_main_grid .postcode_check_grid .posthead span.postcode-form-toggle-switch", function () {
            e(".postcode-second-container").hide(), e(".postcode_form_grid").show();
        }),
        e(".delivery-postcode-form #postcode_check").on("click", function (s) {
            s.preventDefault();
            var o = e("#postal_code").val();
            -1 !== e.inArray(o, [])
                ? (e(".delivery-postcode-form .success-message").show(), e(".delivery-postcode-form .error-message").hide())
                : (e(".delivery-postcode-form .success-message").hide(), e(".delivery-postcode-form .error-message").show());
        }),
        e(".free_shipping_form_same #postcode_check").on("click", function (s) {
            s.preventDefault();
            var o = e(".free_shipping_form_same #postal_code").val();
            -1 !==
            e.inArray(o, [
                "4508",
                "4505",
                "4503",
                "4502",
                "4501",
                "4500",
                "4304",
                "4303",
                "4301",
                "4179",
                "4300",
                "4178",
                "4174",
                "4173",
                "4172",
                "4171",
                "4170",
                "4169",
                "4164",
                "4163",
                "4161",
                "4158",
                "4159",
                "4160",
                "4157",
                "4156",
                "4509",
                "4155",
                "4154",
                "4153",
                "4152",
                "4151",
                "4133",
                "4132",
                "4131",
                "4130",
                "4129",
                "4128",
                "4127",
                "4123",
                "4122",
                "4121",
                "4120",
                "4119",
                "4118",
                "4117",
                "4116",
                "4115",
                "4114",
                "4113",
                "4112",
                "4111",
                "4110",
                "4109",
                "4108",
                "4107",
                "4106",
                "4105",
                "4104",
                "4103",
                "4102",
                "4101",
                "4078",
                "4077",
                "4076",
                "4075",
                "4074",
                "4073",
                "4072",
                "4068",
                "4067",
                "4066",
                "4065",
                "4064",
                "4061",
                "4060",
                "4059",
                "4054",
                "4000",
                "4005",
                "4001",
                "4006",
                "4007",
                "4008",
                "4009",
                "4010",
                "4011",
                "4012",
                "4013",
                "4014",
                "4017",
                "4018",
                "4020",
                "4019",
                "4021",
                "4022",
                "4025",
                "4030",
                "4031",
                "4032",
                "4034",
                "4035",
                "4037",
                "4053",
                "4051",
                "5087",
                "5086",
                "5084",
                "5085",
                "5062",
                "5061",
                "5052",
                "5051",
                "5048",
                "5049",
                "5047",
                "5035",
                "5037",
                "5038",
                "5039",
                "5040",
                "5041",
                "5042",
                "5043",
                "5044",
                "5045",
                "5046",
                "5083",
                "5082",
                "5081",
                "5075",
                "5074",
                "5073",
                "5072",
                "5070",
                "5069",
                "5067",
                "5068",
                "5065",
                "5066",
                "5063",
                "5064",
                "5158",
                "5132",
                "5127",
                "5126",
                "5125",
                "5113",
                "5112",
                "5109",
                "5108",
                "5107",
                "5106",
                "5098",
                "5097",
                "5096",
                "5095",
                "5094",
                "5093",
                "5092",
                "5091",
                "5090",
                "5089",
                "5088",
                "5010",
                "5011",
                "5012",
                "5013",
                "5014",
                "5015",
                "5016",
                "5017",
                "5018",
                "5019",
                "5020",
                "5021",
                "5022",
                "5023",
                "5024",
                "5025",
                "5031",
                "5032",
                "5033",
                "5034",
                "5009",
                "5008",
                "5007",
                "5006",
                "5005",
                "5000",
                "5111",
                "5160",
                "5161",
                "5162",
                "5164",
                "5165",
                "5166",
                "5950",
                "5169",
                "5167",
                "5131",
                "5174",
                "5173",
                "5121",
                "5120",
                "5118",
                "5117",
                "5050",
                "5116",
                "2641",
                "2600",
                "2601",
                "2602",
                "2603",
                "2604",
                "2605",
                "2606",
                "2607",
                "2608",
                "2609",
                "2612",
                "2614",
                "2615",
                "2617",
                "2619",
                "2900",
                "2902",
                "2903",
                "2904",
                "2905",
                "2906",
                "2911",
                "2912",
                "2913",
                "2914",
                "2530",
                "2529",
                "2528",
                "2527",
                "2526",
                "2525",
                "2519",
                "2518",
                "2517",
                "2516",
                "2515",
                "2508",
                "2506",
                "2505",
                "2502",
                "2500",
                "2762",
                "2753",
                "2568",
                "2082",
                "2080",
                "2079",
                "3977",
                "3976",
                "3975",
                "3910",
                "3805",
                "3804",
                "3803",
                "3802",
                "3207",
                "3206",
                "3205",
                "3204",
                "3202",
                "3201",
                "3200",
                "3199",
                "3198",
                "3197",
                "3196",
                "3195",
                "3194",
                "3193",
                "3192",
                "3191",
                "3190",
                "3189",
                "3188",
                "3187",
                "3186",
                "3185",
                "3184",
                "3183",
                "3182",
                "3181",
                "3180",
                "3179",
                "3178",
                "3177",
                "3175",
                "3174",
                "3173",
                "3172",
                "3171",
                "3170",
                "3169",
                "3168",
                "3167",
                "3166",
                "3165",
                "3163",
                "3162",
                "3161",
                "3155",
                "3154",
                "3153",
                "3152",
                "3151",
                "3150",
                "3149",
                "3148",
                "3147",
                "3146",
                "3145",
                "3144",
                "3143",
                "3142",
                "3141",
                "3140",
                "3138",
                "3137",
                "3135",
                "3133",
                "3132",
                "3131",
                "3130",
                "3129",
                "3128",
                "3127",
                "3126",
                "3125",
                "3124",
                "3123",
                "3122",
                "3121",
                "3116",
                "3111",
                "3109",
                "3108",
                "3107",
                "3106",
                "3105",
                "3104",
                "3103",
                "3102",
                "3101",
                "3094",
                "3093",
                "3088",
                "3087",
                "3086",
                "3085",
                "3084",
                "3083",
                "3082",
                "3081",
                "3079",
                "3078",
                "3076",
                "3075",
                "3074",
                "3073",
                "3072",
                "3071",
                "3070",
                "3068",
                "3067",
                "3066",
                "3065",
                "3062",
                "3061",
                "3060",
                "3058",
                "3057",
                "3056",
                "3055",
                "3054",
                "3053",
                "3052",
                "3051",
                "3050",
                "3047",
                "3046",
                "3045",
                "3044",
                "3042",
                "3041",
                "3040",
                "3039",
                "3038",
                "3036",
                "3034",
                "3033",
                "3032",
                "3031",
                "3029",
                "3028",
                "3027",
                "3026",
                "3025",
                "3023",
                "3022",
                "3021",
                "3020",
                "3019",
                "3018",
                "3016",
                "3015",
                "3013",
                "3012",
                "3011",
                "3008",
                "3006",
                "3005",
                "3004",
                "3003",
                "3002",
                "3000",
                "3356",
                "3355",
                "3354",
                "3350",
                "3220",
                "3219",
                "3218",
                "3217",
                "3216",
                "3215",
                "3214",
                "3212",
                "3629",
                "3630",
                "3631",
                "3978",
                "3944",
                "3943",
                "3941",
                "3940",
                "3939",
                "3938",
                "3937",
                "3936",
                "3934",
                "3933",
                "3931",
                "3930",
                "3929",
                "3928",
                "3927",
                "3926",
                "3920",
                "3919",
                "3918",
                "3916",
                "3915",
                "3913",
                "3912",
                "3810",
                "3809",
                "3808",
                "3807",
                "3806",
                "3799",
                "3797",
                "3796",
                "3795",
                "3793",
                "3792",
                "3791",
                "3789",
                "3788",
                "3787",
                "3786",
                "3785",
                "3783",
                "3782",
                "3781",
                "3778",
                "3777",
                "3775",
                "3770",
                "3767",
                "3766",
                "3765",
                "3763",
                "3762",
                "3761",
                "3760",
                "3759",
                "3758",
                "3757",
                "3756",
                "3755",
                "3754",
                "3753",
                "3752",
                "3751",
                "3750",
                "3711",
                "3660",
                "3658",
                "3555",
                "3458",
                "3442",
                "3441",
                "3440",
                "3438",
                "3437",
                "3435",
                "3434",
                "3433",
                "3432",
                "3431",
                "3430",
                "3429",
                "3428",
                "3427",
                "3358",
                "3342",
                "3341",
                "3340",
                "3338",
                "3337",
                "3336",
                "3335",
                "3329",
                "3328",
                "3250",
                "3230",
                "3228",
                "3227",
                "3226",
                "3225",
                "3223",
                "3222",
                "3160",
                "3159",
                "3158",
                "3139",
                "3115",
                "3114",
                "3113",
                "3099",
                "3097",
                "3096",
                "3091",
                "3090",
                "3089",
                "3064",
                "3063",
                "3059",
                "3049",
                "3048",
                "3942",
                "3921",
                "3779",
                "3745",
                "3738",
                "3737",
                "3735",
                "3726",
                "3722",
                "3720",
                "3719",
                "3718",
                "3717",
                "3715",
                "3714",
                "3713",
                "3712",
                "3690",
                "3678",
                "3677",
                "3675",
                "3673",
                "3672",
                "3670",
                "3665",
                "3664",
                "3663",
                "3659",
                "3649",
                "3647",
                "3646",
                "3644",
                "3641",
                "3640",
                "3639",
                "3638",
                "3637",
                "3636",
                "3635",
                "3634",
                "3633",
                "3624",
                "3623",
                "3622",
                "3621",
                "3620",
                "3618",
                "3617",
                "3616",
                "3614",
                "3612",
                "3610",
                "3608",
                "3607",
                "3597",
                "3596",
                "3595",
                "3594",
                "3590",
                "3589",
                "3588",
                "3586",
                "3585",
                "3578",
                "3575",
                "3565",
                "3564",
                "3562",
                "3537",
                "3494",
                "3447",
                "3446",
                "3422",
                "3412",
                "3374",
                "3334",
                "3332",
                "3330",
                "3325",
                "3324",
                "3323",
                "3322",
                "3310",
                "3309",
                "3305",
                "3304",
                "3303",
                "3301",
                "3300",
                "3289",
                "3287",
                "3286",
                "3285",
                "3284",
                "3283",
                "3282",
                "3281",
                "3280",
                "3279",
                "3278",
                "3277",
                "3273",
                "3272",
                "3271",
                "3270",
                "3269",
                "3268",
                "3267",
                "3266",
                "3265",
                "3264",
                "3260",
                "3254",
                "3251",
                "3243",
                "3239",
                "3232",
                "3987",
                "3900",
                "3854",
                "3852",
                "3842",
                "3840",
                "3832",
                "3820",
                "3816",
                "3815",
                "3814",
                "3813",
                "3812",
                "3764",
                "3744",
                "3723",
                "3599",
                "3591",
                "3584",
                "3583",
                "3581",
                "3580",
                "3579",
                "3568",
                "3567",
                "3566",
                "3549",
                "3546",
                "3544",
                "3542",
                "3540",
                "3533",
                "3531",
                "3530",
                "3529",
                "3505",
                "3501",
                "3500",
                "3498",
                "3496",
                "3487",
                "3485",
                "3483",
                "3482",
                "3480",
                "3478",
                "3477",
                "3475",
                "3472",
                "3469",
                "3468",
                "3467",
                "3464",
                "3424",
                "3423",
                "3420",
                "3419",
                "3418",
                "3415",
                "3414",
                "3413",
                "3408",
                "3407",
                "3401",
                "3400",
                "3396",
                "3395",
                "3393",
                "3392",
                "3391",
                "3390",
                "3388",
                "3387",
                "3385",
                "3384",
                "3381",
                "3379",
                "3378",
                "3371",
                "3370",
                "3363",
                "3361",
                "3360",
                "3319",
                "3318",
                "3317",
                "3315",
                "3314",
                "3312",
                "3311",
                "3302",
                "3294",
                "3293",
                "3292",
                "3276",
                "3275",
                "3274",
                "3233",
                "2770",
                "2769",
                "2768",
                "2767",
                "2766",
                "2763",
                "2761",
                "2760",
                "2759",
                "2750",
                "2749",
                "2748",
                "2747",
                "2745",
                "2567",
                "2566",
                "2565",
                "2564",
                "2559",
                "2558",
                "2557",
                "2556",
                "2234",
                "2231",
                "2228",
                "2227",
                "2226",
                "2225",
                "2224",
                "2223",
                "2222",
                "2221",
                "2220",
                "2219",
                "2218",
                "2217",
                "2216",
                "2214",
                "2213",
                "2212",
                "2211",
                "2210",
                "2209",
                "2208",
                "2207",
                "2206",
                "2205",
                "2204",
                "2203",
                "2200",
                "2199",
                "2198",
                "2197",
                "2196",
                "2195",
                "2194",
                "2193",
                "2192",
                "2191",
                "2190",
                "2177",
                "2176",
                "2174",
                "2173",
                "2171",
                "2170",
                "2168",
                "2167",
                "2166",
                "2165",
                "2164",
                "2163",
                "2162",
                "2161",
                "2160",
                "2158",
                "2157",
                "2156",
                "2155",
                "2154",
                "2153",
                "2152",
                "2151",
                "2150",
                "2148",
                "2147",
                "2146",
                "2145",
                "2144",
                "2143",
                "2142",
                "2141",
                "2140",
                "2138",
                "2137",
                "2136",
                "2135",
                "2134",
                "2133",
                "2132",
                "2131",
                "2130",
                "2128",
                "2127",
                "2126",
                "2125",
                "2122",
                "2121",
                "2120",
                "2119",
                "2118",
                "2117",
                "2116",
                "2115",
                "2114",
                "2113",
                "2112",
                "2111",
                "2110",
                "2108",
                "2107",
                "2106",
                "2105",
                "2104",
                "2103",
                "2102",
                "2101",
                "2100",
                "2099",
                "2097",
                "2096",
                "2095",
                "2094",
                "2093",
                "2092",
                "2090",
                "2089",
                "2088",
                "2087",
                "2086",
                "2085",
                "2084",
                "2077",
                "2076",
                "2075",
                "2073",
                "2072",
                "2071",
                "2070",
                "2069",
                "2068",
                "2067",
                "2066",
                "2065",
                "2064",
                "2063",
                "2062",
                "2061",
                "2060",
                "2050",
                "2049",
                "2048",
                "2047",
                "2046",
                "2045",
                "2044",
                "2043",
                "2042",
                "2041",
                "2040",
                "2039",
                "2038",
                "2037",
                "2036",
                "2035",
                "2034",
                "2033",
                "2032",
                "2031",
                "2030",
                "2029",
                "2028",
                "2027",
                "2026",
                "2025",
                "2024",
                "2023",
                "2022",
                "2021",
                "2020",
                "2019",
                "2018",
                "2017",
                "2016",
                "2015",
                "2011",
                "2010",
                "2009",
                "2008",
                "2007",
                "2006",
                "2000",
                "2229",
                "2233",
                "5163",
                "5159",
                "5110",
                "5168",
                "5114",
                "5115",
                "5231",
                "3024",
                "3030",
                "3156",
                "3037",
                "3043",
                "3095",
                "3134",
                "3136",
                "3911",
                "3213",
                "3211",
                "3321",
                "3221",
                "3224",
                "3231",
                "3240",
                "3331",
                "3333",
                "3351",
                "3835",
                "3694",
                "3377",
                "3375",
                "3409",
                "3687",
                "3693",
                "3380",
                "3847",
                "3981",
                "3984",
            ])
                ? (e(".free_shipping_form_same .success-message").show(), e(".free_shipping_form_same .error-message").hide())
                : (e(".free_shipping_form_same .success-message").hide(), e(".free_shipping_form_same .error-message").show());
        });
    
    function $(e) {
        var e = parseFloat(e / 100).toFixed(2);
        return e;
    }
        e("#post_check_form").on("submit", function (s) {
          s.preventDefault(), e("button#product_detail_custom_add_to_cart").is(":disabled") && e("button#product_detail_custom_add_to_cart").removeAttr("disabled");
          var t = e("#post_check_form #post_check").val(),
          n = "not found";
          
          var productid = e('.post_check_main_grid').data('id');
          var type = e('.post_check_main_grid').data('type');
          var tags = e('.post_check_main_grid').data('tags');
          var product_name = e('.post_check_main_grid').data('ptitle');
          
          if (
              (e(".postcode-second-container").show(),
              setTimeout(() => {
                  e(".form-inner-wrap").show();
              }, 4e3),
              "" !== t)
          ) {
              localStorage.setItem("postalCode", t), e(".postcode_check_grid").append('<div class="shipping_zip_loader"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>');
              var a = e('.product__info-wrapper product-form.product-form input[name="id"]').val();
              var sku = e('.product__info-wrapper product-form.product-form input[name="id"]').attr('data-sku');
              var price = e('.product__info-wrapper product-form.product-form input[name="id"]').attr('data-price');

              if ((e(".shiping_with_deliverd .shipping_rate").html(""), "" != a && null != a && "undefined" != a)) {
                  var d = e(".InventoryManagment_sec_" + a + " span").attr("data-stock-type"),
                      l = e(".InventoryManagment_sec_" + a + " span").html();
                  "In Stock" == d
                      ? (e(".quantity-avl-grid").removeClass("hide"), e(".quantity-avl").text(l), e(".quantity-avl").removeClass("quantity-out"), e(".quantity-avl").hide(), e(".dispatch_deatil .disp-main").show())
                      : "Out of Stock" == d
                      ? (e(".quantity-avl-grid").removeClass("hide"), e(".quantity-avl").text(l), e(".quantity-avl").addClass("quantity-out"), e(".quantity-avl").hide(), e(".dispatch_deatil .disp-main").hide())
                      : (e(".quantity-avl-grid").addClass("hide"), e(".dispatch_deatil .disp-main").show());
                  var y = e('.variation_product_weight span[data-id="' + a + '"]').html(),
                      i = e(".post_check_main_grid").attr("data-id");
                  var shop = Shopify.shop;

                  if (null != y && "undefined" != y)
                      e.ajax({
                          type: "POST",
                          /* url: "https://shipping.logiceverest.com/calculate-rates",
                          data: { product_id: i, zip: t, grams: y, currency: "AUD" }, */
                          url: 'https://sbz.cirkleinc.com/front-widget',
                          data: {
                              rate: {
                                destination: {
                                  postal_code: t,
                                  province: 'QLD',
                                  city: 'Lifely',
                                  country: 'AU'
                                },
                                origin:{
                                  address: '2/9 Leakes Rd',
                                  postal_code: 3026,
                                  province: 'VIC',
                                  country: 'AU'
                                },
                                items: [
                                  {
                                    product_id: productid,
                                    variant_id: a,
                                    sku: sku,
                                    type: type,
                                    tag: tags,
                                    name: product_name,
                                    quantity: 1,
                                    grams: y,
                                    price: price,
                                    vendor: 'little-lifely.myshopify.com'
                                  }
                                ]
                              },
                              shop: shop
                          },
                          crossDomain: !0,
                          dataType: "json",
                          success: function (s) {
                              if(s.rates != '' && s.rates != 'undefined' && s.rates != null){
                                  e('.post_code_error').hide();
                                  e('.postcode-second-container').show();
                                  if ("Unable to Ship to this Postcode" == s.rates[0].service_name) {
                                      console.log("asdadadasdadasd"),
                                          setTimeout(function () {
                                              e(".csv_result_show").hide(), e("#post_check_form").show(), e(".post_code_error").show().css("display", "flex");
                                          }, 3e3);
                                      return;
                                  }
                                  if (s.rates[0].total_price > 0) {
                                      var o = $(s.rates[0].total_price);
                                      e(".shiping_with_deliverd .shipping_rate").html(s.rates[0].service_name + " $" + o),
                                          e(".csv_result_show p.shipping_deatil .shipping_fee").html('<span class="price Test_1">$' + o + "</span> shipping fee"),
                                          e(".csv_result_show p.shipping_deatil .date-free-ship").hide(),
                                          (n = "found");
                                  } else {
                                          (e(".shiping_with_deliverd .shipping_rate").html(s.rates[0].service_name),
                                          e(".csv_result_show p.shipping_deatil .shipping_fee").html('<span class="price Test_2">FREE</span> shipping fee'),
                                          e(".csv_result_show p.shipping_deatil .date-free-ship").show(),
                                          (n = "found"));
                                  }
                              }else{ 
                                  setTimeout(function () {
                                      e('.post_code_error').show();
                                      e('.postcode-second-container').hide();
                                  }, 2000);
                              }
                          },
                      });
                  else {
                      var y = e("#defaultWeight").val();
                      y = y.replace(/kg/g, "").replace(/\s/g, "");
                      var u = parseFloat(0.21),
                          D = parseFloat(11.18),
                          r = y * u + D;
                      (r = parseFloat(r.toFixed(2))), e(".csv_result_show p.shipping_deatil .shipping_fee").html('<span class="price Test_3">$' + r + "</span> shipping fee");
                  }
              }
              setTimeout(function () {
                  if (e(".postcode_form_grid span.pre_order_item").length) {
                      var s = e('.product__info-wrapper product-form.product-form form input[name="id"]').val();
                      if ("" != e(".postcode_form_grid .form-note").attr("data-dispatch") && null != e(".postcode_form_grid .form-note").attr("data-dispatch") && "undefined" != e(".postcode_form_grid .form-note").attr("data-dispatch"))
                          var a = e.trim(e(".postcode_form_grid .form-note").attr("data-dispatch"));
                      else var a = "";
                      if ("" != s && null != s && "undefined" != s) {
                          var d = "";
                          if (
                              (e(".postcode_form_grid span.pre_order_item").each(function () {
                                  e(this).text() == s &&
                                      ((d = "true"),
                                      "" != e(this).attr("data-dispatch-date") && null != e(this).attr("data-dispatch-date") && "undefined" != e(this).attr("data-dispatch-date") && (a = e.trim(e(this).attr("data-dispatch-date"))));
                              }),
                              "true" == d && "" != a && null != a && "undefined" != a)
                          ) {

                            console.log(a);

                              let l = new Date(a),
                                  y = new Date();

                              if (y < l) {
                                  let i = l.getDate() + " " + ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][l.getMonth()] + " " + l.getFullYear();
                                  e(".postcode_form_grid .form-note .span_dispatch_note").text("Available On : " + i),
                                      e(".csv_result_show .dispatch_deatil .dispatch_label").html("Available On: "),
                                      e(".csv_result_show .dispatch_deatil .dispatch_date").html(i);
                              } else
                                  e(".postcode_form_grid .form-note .span_dispatch_note").text("Dispatch in 24 hours"),
                                      e(".csv_result_show .dispatch_deatil .dispatch_label").html("Dispatch in "),
                                      e(".csv_result_show .dispatch_deatil .dispatch_date").html("24 hours");
                          } else e(".csv_result_show .dispatch_deatil .dispatch_label").html("Dispatch in "), e(".csv_result_show .dispatch_deatil .dispatch_date").html("24 hours");
                      }
                  }
                  var u = "";
                  if (o) {
                      for (var D = !1, r = 0; r < o.length && !D; r++) {
                          var c = o[r],
                              p = c.postcode,
                              I = c.state,
                              b = "";
                          c.state;
                          let _ = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                          if (t == p) {
                              if ("" != (b = c.ddays) || "undefined" != b) {
                                  for (var w = b.split("-"), L = w[0], E = w[1].split(" ")[0], F = (new Date().toISOString(), new Date().toISOString()), B = new Date(F), $ = new Date(F), m = "", f = L, A = 0; A < f; )
                                      0 != (m = new Date(B.setDate(B.getDate() + 1))).getDay() && 6 != m.getDay() && A++;
                                  for (var W = "", f = E, A = 0; A < f; ) 0 != (W = new Date($.setDate($.getDate() + 1))).getDay() && 6 != W.getDay() && A++;
                                  var h = m.getDate(),
                                      v = _[m.getMonth()],
                                      g = W.getDate(),
                                      T = _[W.getMonth()];   

                                  if (e(window).width() > 600)
                                      var N = T + " " + g,
                                          C = v + " " + h;
                                  else
                                      var N = T.substr(0, 3) + " " + g,
                                          C = v.substr(0, 3) + " " + h;
                              }
                              if (((u += C + " - " + N), "" != I && null != I && "undefined" != I)) var O = I + "," + t;
                              else var O = t;
                          }
                          if ("" == u)
                              e(".post_code_error").css("display", "flex"),
                                  e(".postcode_check_grid .posthead").html(
                                      'Delivery <span class="postcode-form-toggle-switch"><img src="//cdn.shopify.com/s/files/1/0562/7569/7706/files/edit-button.png?v=1738536258" height="20px" alt="icon"></span>'
                                  ),
                                  e(".csv_result_show").hide();
                          else {
                              e("#post_check_form").attr("shipping-date", u),
                                  e("#post_check_form").attr("shipping-address", O),
                                  e(".post_code_error").css("display", "none"),
                                  e(".postcode_form_grid .post_form_head").hide(),
                                  "true" == d
                                      ? (e(".csv_result_show p.delivery_detail span.delivery_date").html("Not Eligible"), S())
                                      : (e("#csv-display .exect_date").html(u), e(".csv_result_show p.delivery_detail span.delivery_date").html(u), console.log("------------------")),
                                      console.log(u)  
                                      console.log("-------1111-----------")

                                  e("div#csv-display h3.diliverd_to span:first-child").html(O),
                                  e(".postcode_check_grid .posthead").html(
                                      "Delivery to: <span>" +
                                          O +
                                          '</span> <span class="postcode-form-toggle-switch"><img src="//cdn.shopify.com/s/files/1/0562/7569/7706/files/edit-button.png?v=1738536258" height="20px" alt="icon"></span>'
                                  ),
                                  e(".csv_result_show").show(),
                                  (D = !0);
                              break;
                          }
                      }
                      "" == u &&
                          (e("#post_check_form").attr("shipping-date", ""),
                          e("#post_check_form").attr("shipping-address", ""),
                          "found" == n
                              ? (e(".post_code_error").css("display", "none"),
                                e(".postcode_form_grid .post_form_head").hide(),
                                e(".csv_result_show p.delivery_detail span.delivery_date").html("Not Eligible"),
                                e("div#csv-display h3.diliverd_to span:first-child").html(t),
                                e(".postcode_check_grid .posthead").html(
                                    "Delivery to: <span>" + t + '</span> <span class="postcode-form-toggle-switch"><img src="//cdn.shopify.com/s/files/1/0562/7569/7706/files/edit-button.png?v=1738536258" height="20px" alt="icon"></span>'
                                ),
                                e(".csv_result_show").show())
                              : (e(".post_code_error").css("display", "flex"),
                                e(".postcode_check_grid .posthead").html(
                                    'Delivery <span class="postcode-form-toggle-switch"><img src="//cdn.shopify.com/s/files/1/0562/7569/7706/files/edit-button.png?v=1738536258" height="20px" alt="icon"></span>'
                                ),
                                e(".csv_result_show").hide())),
                          e(".shipping_zip_loader").remove();
                  }
                  e(".add_to_cart_loader_form").remove();
              }, 2e3);
          } else e(".add_to_cart_loader_form").remove();
          e(".postcode-second-container").show();
          }),
      
        e("div#csv-display span.edit_shipping_postcode").click(function (s) {
            s.preventDefault(), e("#csv-display").hide(), e(".postcode_form_grid .post_form_head").show(), e(".form-inner-wrap").show(), e(".postcode-second-container").hide();
        });

    var f = null;
  
    function S() {
        var s = document.querySelector(".delivery_date");
        if (s && "Not Eligible" === s.textContent.trim()) {
            var o = document.getElementById("post_check_form").getAttribute("shipping-date").split(" - ")[0],
                t = new Date(o + ", " + new Date().getFullYear()) - new Date(),
                n = document.querySelector(".dispatch_date");
            if (n) {
                let a;
                const rawDispatchText = n.textContent.trim().toLowerCase(); 
                if (rawDispatchText.includes('24 hours')) {
                  a = new Date();
                  a.setDate(a.getDate() + 1); // Add 1 day
                }else{
                  // Try to parse as date if it's a real date string
                  a = new Date(`${rawDispatchText}, ${new Date().getFullYear()}`);
                }
              
                if (isNaN(a.getTime())) {
                  console.error('Invalid dispatch date:', rawDispatchText);
                  return;
                }
                
                /* var a = new Date(n.textContent.trim());
                a.setDate(a.getDate() + Math.ceil(t / 864e5)); */
                var d = new Date(a);
                d.setDate(d.getDate() + 7);
                var l = a.toLocaleString("default", { month: "long" }),
                    y = a.getDate(),
                    i = d.toLocaleString("default", { month: "long" }),
                    u = d.getDate(),
                    D = a.getFullYear(),
                    r = document.querySelector(".posthead span");
                r ? r.textContent : console.error(".posthead span element not found."),
                    (s.textContent = l + " " + y + " - " + i + " " + u + ", " + D),
                    e(".preOrder-updates").html("<span class='preOrder-class'>Pre Order Now - ETA " + y + " " + l + " - " + u + " " + i + " </span>"),
                    e(".preOrder-updates").addClass("999999999");
            }
        }
    }
  
    if (
        (setTimeout(function () {
            "Out of Stock" === e("span.quantity-avl.quantity-out").text().trim() ? e(".delivery_detail").hide() : e(".delivery_detail").show();
        }, 3e3),
        e(document).on("change", "variant-selects fieldset.product-form__input input", function () {
            setTimeout(function () {
                var s = e("#post_check_form #post_check").val(),
				o = e('.product__info-wrapper product-form.product-form input[name="id"]').val();
				
                var productid = e('.post_check_main_grid').data('id');
				var type = e('.post_check_main_grid').data('type');
				var tags = e('.post_check_main_grid').data('tags');
				var product_name = e('.post_check_main_grid').data('ptitle');
				
				var sku = e('.product__info-wrapper product-form.product-form input[name="id"]').data('sku');
				var price = e('.product__info-wrapper product-form.product-form input[name="id"]').data('price');
					
                if ((e(".preorder_discout_bar p").hide(), "" != o && null != o && "undefined" != o)) {
                    var t = e(".InventoryManagment_sec_" + o + " span").attr("data-stock-type"),
                        n = e(".InventoryManagment_sec_" + o + " span").html();
                    e(".product_main_thumb_grid_sec .product_thumb_batches .preorder_label").length,
                        "In Stock" == t
                            ? (e(".quantity-avl-grid").show(), e(".quantity-avl").text(n), e(".quantity-avl").removeClass("quantity-out"), e(".quantity-avl").show(), e(".dispatch_deatil .disp-main").show(), e(".delivery_detail").show())
                            : "Out of Stock" == t
                            ? (e(".quantity-avl-grid").show(), e(".quantity-avl").text(n), e(".quantity-avl").addClass("quantity-out"), e(".quantity-avl").show(), e(".dispatch_deatil .disp-main").hide(), e(".delivery_detail").hide())
                            : (e(".quantity-avl-grid").hide(), e(".dispatch_deatil .disp-main").show());
                    var a = "";
                    e(".postcode_form_grid span.pre_order_item").each(function () {
                        e(this).text() == o && (a = "true");
                    }),
                        "true" == a
                            ? (e(".quantity-avl-grid").hide(),
                              e(".prder_order_listing").show(),
                              e(".quantity-avl").hide(),
                              setTimeout(function () {}, 1500),
                              e('.preorder_discout_bar p[data-id="' + o + '"]').show(),
                              e(".product_main_thumb_grid_sec .product_thumb_batches .preorder_label").length)
                            : (e(".quantity-avl-grid").show(),
                              e(".quantity-avl").show(),
                              e(".prder_order_listing").hide(),
                              "In Stock" == t
                                  ? setTimeout(function () {
                                        e("button#product_detail_custom_add_to_cart > span").html("Add to cart");
                                    }, 1500)
                                  : "Out of Stock" == t &&
                                    setTimeout(function () {
                                        e("button#product_detail_custom_add_to_cart > span").html("Sold Out");
                                    }, 1500),
                              e(".preorder_discout_bar p").hide(),
                              e(".product_main_thumb_grid_sec .product_thumb_batches .preorder_label").remove());
                }
                if ("" !== s) {
                    var d = "not found",
                        o = e('.product__info-wrapper product-form.product-form input[name="id"]').val();
                    if ((e(".shiping_with_deliverd .shipping_rate").html(""), "" != o && null != o && "undefined" != o)) {
                        var t = e(".InventoryManagment_sec_" + o + " span").attr("data-stock-type"),
                            n = e(".InventoryManagment_sec_" + o + " span").html();
                        "In Stock" == t
                            ? (e(".quantity-avl-grid").removeClass("hide"), e(".quantity-avl").text(n), e(".quantity-avl").removeClass("quantity-out"), e(".quantity-avl").show(), e(".dispatch_deatil .disp-main").show())
                            : "Out of Stock" == t
                            ? (e(".quantity-avl-grid").removeClass("hide"), e(".quantity-avl").text(n), e(".quantity-avl").addClass("quantity-out"), e(".quantity-avl").show(), e(".dispatch_deatil .disp-main").hide())
                            : (e(".quantity-avl-grid").addClass("hide"), e(".dispatch_deatil .disp-main").show());
                        var l = e('.variation_product_weight span[data-id="' + o + '"]').html(),
                            y = e(".post_check_main_grid").attr("data-id");
                        var shop = Shopify.shop;

                        null != l &&
                            "undefined" != l &&
                            (f = e.ajax({
                                type: "POST",
								url: 'https://sbz.cirkleinc.com/front-widget',
								data: {
									rate: {
									  destination: {
										postal_code: s,
										province: 'QLD',
										city: 'Lifely',
										country: 'AU'
									  },
									  origin:{
										address: '2/9 Leakes Rd',
										postal_code: 3026,
										province: 'VIC',
										country: 'AU'
									  },
									  items: [
										{
										  product_id: productid,
										  variant_id: o,
										  sku: sku,
										  type: type,
										  tag: tags,
										  name: product_name,
										  quantity: 1,
										  grams: l,
										  price: price,
										  vendor: 'little-lifely.myshopify.com'
										}
									  ]
									},
									shop: shop
								},
                                crossDomain: !0,
                                dataType: "json",
                                beforeSend: function () {
                                    null != f && f.abort();
                                },
                                success: function (s) {
                                    if (s.rates[0].total_price > 0) {
                                        var o = $(s.rates[0].total_price);
                                        e(".shiping_with_deliverd .shipping_rate").html(s.rates[0].service_name + " $" + o),
                                            e(".csv_result_show p.shipping_deatil .shipping_fee").html('<span class="price">$' + o + "</span> shipping fee"),
                                            e(".csv_result_show p.shipping_deatil .date-free-ship").hide(),
                                            e(".post_check_main_grid .postcode_check_grid .postcode_form_grid p.quantity-avl-grid").show(),
                                            (d = "found");
                                    } else {
                                            (e(".shiping_with_deliverd .shipping_rate").html(s.rates[0].service_name),
                                            e(".csv_result_show p.shipping_deatil .shipping_fee").html('<span class="price">FREE</span> shipping fee'),
                                            e(".csv_result_show p.shipping_deatil .date-free-ship").show(),
                                            (d = "found"),
                                            e(".post_check_main_grid .postcode_check_grid .postcode_form_grid p.quantity-avl-grid").show());
                                    }
                                },
                            }));
                    }
                    setTimeout(function () {
                        var s = "";
                        if (e(".postcode_form_grid span.pre_order_item").length) {
                            var o = e('.product__info-wrapper product-form.product-form form input[name="id"]').val();
                            if (
                                "" != e(".postcode_form_grid .form-note").attr("data-dispatch") &&
                                null != e(".postcode_form_grid .form-note").attr("data-dispatch") &&
                                "undefined" != e(".postcode_form_grid .form-note").attr("data-dispatch")
                            )
                                var t = e.trim(e(".postcode_form_grid .form-note").attr("data-dispatch"));
                            else var t = "";
                            if ("" != o && null != o && "undefined" != o) {
                                var s = "";
                                if (
                                    (e(".postcode_form_grid span.pre_order_item").each(function () {
                                        e(this).text() == o &&
                                            ((s = "true"),
                                            "" != e(this).attr("data-dispatch-date") && null != e(this).attr("data-dispatch-date") && "undefined" != e(this).attr("data-dispatch-date") && (t = e.trim(e(this).attr("data-dispatch-date"))));
                                    }),
                                    "true" == s && "" != t && null != t && "undefined" != t)
                                ) {
                                    let n = new Date(t),
                                        a = new Date();
                                    if (a < n) {
                                        let d = n.getDate() + " " + ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][n.getMonth()] + " " + n.getFullYear();
                                        e(".postcode_form_grid .form-note .span_dispatch_note").text("Available On : " + d),
                                            e(".csv_result_show .dispatch_deatil .dispatch_label").html("Available On: "),
                                            e(".csv_result_show .dispatch_deatil .dispatch_date").html(d);
                                    } else
                                        e(".postcode_form_grid .form-note .span_dispatch_note").text("Dispatch in 24 hours"),
                                            e(".csv_result_show .dispatch_deatil .dispatch_label").html("Dispatch in "),
                                            e(".csv_result_show .dispatch_deatil .dispatch_date").html("24 hours");
                                } else e(".csv_result_show .dispatch_deatil .dispatch_label").html("Dispatch in "), e(".csv_result_show .dispatch_deatil .dispatch_date").html("24 hours");
                            }
                        }
                        if ("true" == s) e(".csv_result_show p.delivery_detail span.delivery_date").html("Not Eligible"), S();
                        else {
                            var l,
                                y,
                                i = e("form#post_check_form").attr("shipping-date");
                            e(".csv_result_show p.delivery_detail span.delivery_date").html(i),
                                console.log("1111111111111111111111"),
                                (l = e(".delivery_date").text()),
                                e(".cart-line-item-dates").val(l),
                                (y = e(".post_check_main_grid .posthead span").text()),
                                e(".cart-line-item-postcode").val(y);
                        }
                    }, 500);
                }
            }, 2000);
        }),
        e("body").hasClass("cart") && e("body.cart table.cart-items").length)
    ) {
        var A = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        e("body.cart table.cart-items .cart-item-dispatch").each(function () {
            if ("true" == e(this).attr("data-pre") && "" != e(this).attr("data-dispatch") && null != e(this).attr("data-dispatch") && "undefined" != e(this).attr("data-dispatch")) {
                var s = e.trim(e(this).attr("data-dispatch")),
                    o = new Date(s);
                if (new Date() < o) {
                    let t = o.getDate() + " " + A[o.getMonth()] + " " + o.getFullYear();
                    e(this)
                        .find("span.span_dispatch_note")
                        .html("Available On : " + t);
                }
            }
        });
    }
    function W(s, t, n, a) {
        var d = "",
            l = o[t],
            y = l.postcode,
            i = "";
        if (a == y) {
            if ("" != (i = l.ddays) || "undefined" != i) {
                for (var u = i.split("-"), D = u[0], r = u[1].split(" ")[0], c = (new Date().toISOString(), new Date().toISOString()), p = new Date(c), I = new Date(c), b = "", _ = D, w = 0; w < _; )
                    0 != (b = new Date(p.setDate(p.getDate() + 1))).getDay() && 6 != b.getDay() && w++;
                for (var L = "", _ = r, w = 0; w < _; ) 0 != (L = new Date(I.setDate(I.getDate() + 1))).getDay() && 6 != L.getDay() && w++;
                var E = b.getDate(),
                    F = n[b.getMonth()],
                    B = L.getDate(),
                    $ = n[L.getMonth()];
                if (e(window).width() > 600)
                    var m = $.substr(0, 3) + " " + B,
                        f = F.substr(0, 3) + " " + E;
                else
                    var m = $.substr(0, 3) + " " + B,
                        f = F.substr(0, 3) + " " + E;
            }
            d += f + " - " + m;
        }
        "" !== d && (e(s).find(".exect_date").html(d), e(s).find(".del-date-bw").html(d), e(s).find(".disptach-date-info").show());
    }
    if (
        (e(document).on("click", ".postcode-check-wrapper .postcode-inner-grid .edit-postcd", function (s) {
            s.preventDefault(), e(".shiping_with_deliverd_cart").hide(), e(".postcode-check-wrapper .postcode-inner-grid").hide(), e(".postcode-check-wrapper .postcode-ck-form").show();
        }),
        setTimeout(function () {
            var s = localStorage.getItem("postalCode");
            null === s && (s = "3000"), e("#post_check_cart").val(s), e("#post_check_form_cart").submit();
        }, 1e4),
        e("#post_check_form_cart").on("submit", function (s) {
            s.preventDefault(), e(".del-date-bw-loader").show();
            var t = e("#post_check_form_cart #post_check_cart").val();
            if (("" === t ? null !== localStorage.getItem("postalCode") && ((t = localStorage.getItem("postalCode")), e("#post_check_form_cart #post_check_cart").val(t)) : localStorage.setItem("postalCode", t), "" !== t)) {
                e(".shiping_with_deliverd_cart").fadeOut(), e("#csv-display-cart").show(), e(".cart-content-right .postcode-check-wrapper .postcode-ck-form").hide(), e(".cart-content-right .postcode-check-wrapper .csv-postcode-msg").hide();
                let n = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                    a = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                var d = "false";
                e(".cart-items .cart-item").each(function () {
                    var s = new Date(e.trim(e(this).find(".cart-item-dispatch").attr("data-dispatch")));
                    let l = new Date();
                    if (l < s)
                        (function s(t, n, a) {
                            var d,
                                l = e(t).attr("data-id"),
                                y = e(t).find(".cart-item-dispatch").attr("data-dispatch"),
                                i = "";
                            if ("" !== y && null !== y && "undefined" !== y && ((i = e.trim(y)), "" !== l && null !== l && "undefined" !== l)) {
                                var u = new Date(i);
                                let D = new Date();
                                var r = o.filter((e) => e.postcode === a);
                                if (D < u && r.length > 0) {
                                    if ("" != (d = r[0].ddays) || "undefined" != d) {
                                        for (var c = d.split("-"), p = c[0], I = c[1].split(" ")[0], b = new Date().toISOString(), _ = new Date(b), w = new Date(b), L = "", E = p, F = 0; F < E; )
                                            0 != (L = new Date(_.setDate(_.getDate() + 1))).getDay() && 6 != L.getDay() && F++;
                                        for (var B = "", E = I, $ = 0; $ < E; ) 0 != (B = new Date(w.setDate(w.getDate() + 1))).getDay() && 6 != B.getDay() && $++;
                                        var m = (function e(s, o) {
                                            var t = s - new Date();
                                            if (o) {
                                                var n = o;
                                                n.setDate(n.getDate() + Math.ceil(t / 864e5));
                                                var a = new Date(n);
                                                a.setDate(a.getDate() + 7);
                                                var d = n.toLocaleString("default", { month: "short" }),
                                                    l = n.getDate(),
                                                    y = a.toLocaleString("default", { month: "short" }),
                                                    i = a.getDate();
                                                return n.getFullYear(), d + " " + l + " - " + y + " " + i;
                                            }
                                        })(L, u);
                                    }
                                    e(t).find(".exect_date").html(m),
                                        e(t).find(".del-date-bw").html(m),
                                        e(t).find(".disptach-date-info").show(),
                                        e(t)
                                            .find(".span_dispatch_note")
                                            .html("Available On : " + new Date(i).toLocaleString("default", { month: "long" }) + " " + new Date(i).getDate() + " " + new Date(i).getFullYear());
                                }
                            }
                        })(e(this), n, t, a),
                            (d = "true");
                    else for (var y = 0; y < o.length; y++) W(e(this), y, n, t);
                });
                var l = o.filter((e) => e.postcode === t)[0].state;
                if ("" != l && null != l && "undefined" != l) var y = l + "," + t;
                else var y = t;
                "VIC" == l || "VICTORIA" == l || "VIC METRO" == l
                    ? e("#address_province").val("Victoria")
                    : "NSW" == l
                    ? e("#address_province").val("New South Wales")
                    : "QLD" == l
                    ? e("#address_province").val("Queensland")
                    : "WA" == l
                    ? e("#address_province").val("Western Australia")
                    : "SA" == l
                    ? e("#address_province").val("South Australia")
                    : "TAS" == l
                    ? e("#address_province").val("Tasmania")
                    : "NT" == l
                    ? e("#address_province").val("Northern Territory")
                    : "ACT" == l && e("#address_province").val("Australian Capital Territory"),
                    e("div#shipping-calculator input#address_zip").val(t),
                    e("div#shipping-calculator input.get-rates.btn.button").trigger("click"),
                    e(".post_code_error_cart").css("display", "none"),
                    e(".postcode-ck-form").hide(),
                    e("div#csv-display-cart .postcode-inner-grid").show(),
                    e("#csv-display-cart .postcode-inner-grid h3 span.text-underlined").html(y),
                    e("#cart-errors").hide(),
                    e(".postcode-inner-grid").show(),
                    e(".del-date-bw-loader").hide();
            }
        }),
        e(".collection_subcategory_bottom_description_sec .collection-hero__subdescription p").length > 1)
    );
});
